import { fetchData, ENDPOINT_HOST } from './api_helper';
import store from '@/store/store';

const apiURL = `${ENDPOINT_HOST}`;


const searchVerificationQuestions = (criteria) => new Promise(((resolve, reject) => {
  var endpointURL = `${apiURL}verification_questions?`;
  if (criteria.categoryId) {
    endpointURL = `${endpointURL}&category_id=${criteria.categoryId}`;
  }
  if (criteria.legalReferenceFilter) {
    endpointURL = `${endpointURL}&legal_reference_filter=${criteria.legalReferenceFilter}`;
  }
  if (criteria.isEdit) {
    endpointURL = `${endpointURL}&is_edit=${criteria.isEdit}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchVerificationQuestions = (criteriaCategoryId,limited,searchTerm = '',self_id) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}criteria_categories/${criteriaCategoryId}/verification_questions?term=${searchTerm}`;
  if(limited && !self_id){
    endpointURL = `${apiURL}criteria_categories/${criteriaCategoryId}/verification_questions?limited=${limited}`;
  }
  if(limited && self_id !== undefined && self_id !== null) {
    endpointURL = `${apiURL}criteria_categories/${criteriaCategoryId}/verification_questions?limited=${limited}&self_id=${self_id}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchVerificationQuestion = (id) => new Promise(((resolve, reject) => {
  const criteriaCategoryId = store.state.criteriaCategories.criteriaCategory.id;
  const endpointURL = `${apiURL}criteria_categories/${criteriaCategoryId}/verification_questions/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));
const fetchVerificationQuestionWithCategoryId = (id,categoryId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}criteria_categories/${categoryId}/verification_questions/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateVerificationQuestion = (id,params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}criteria_categories/${id}/verification_questions/${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createVerificationQuestion = (params) => new Promise(((resolve, reject) => {
  const criteriaCategoryId = store.state.criteriaCategories.criteriaCategory.id;
  const endpointURL = `${apiURL}criteria_categories/${criteriaCategoryId}/verification_questions`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createVerificationQuestionForSubCategory = (params,categoryId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}criteria_categories/${categoryId}/verification_questions`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteVerificationQuestion = (id,categoryId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}criteria_categories/${categoryId}/verification_questions/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

export default {
  fetchVerificationQuestions,
  createVerificationQuestion,
  fetchVerificationQuestion,
  updateVerificationQuestion,
  deleteVerificationQuestion,
  searchVerificationQuestions,
  createVerificationQuestionForSubCategory,
  fetchVerificationQuestionWithCategoryId 
};



// WEBPACK FOOTER //
// ./src/api/verification_questions.js